import React from "react";
import { Offline, Online} from "react-detect-offline";
import { ButtonSecondary, ButtonTertiary } from "../Button";
import styles from "./ErrorMessage.module.scss";
import { ReactComponent as Restart } from "../Screens/Activity/Restart.svg";
import localforage from "localforage";
import log from "../../utils/log";
import AuthenticationError from "../../utils/AuthenticationError";

/**
 * refresh button action
 *
 * reloads the page and deletes cache data if not offline to help clear errors
 */
function refresh() {
  // if not online, just reload
  if (!window?.navigator?.onLine) {
    window?.location?.reload();
    return;
  }

  // if online, remove caches
  if ("caches" in window) {
    try {
      const { caches } = window;
      caches.keys().then((keyList) => {
        Promise.all(
          keyList.map((key) => {
            return caches.delete(key);
          })
        ).then(() => {
          window?.location?.reload();
        });
      });
    } catch (error) {
      if (window.rg4js) {
        rg4js("send", {
          error,
        });
      }

      window?.location?.reload();
    }

    return;
  }

  // reload page
  window?.location?.reload();
}

function deleteUserData() {
  const check = confirm(
    "Are you sure? This will remove all your recorded progress"
  );

  if (!check) {
    return;
  }

  localforage.clear().then(() => {
    window?.location?.reload();
  });
}

export default function ErrorMessage({ error, resetErrorBoundary }) {
  log.error(error);

  // report error
  if (error && window.rg4js) {
    rg4js("send", {
      error,
    });
  }

  const isAuth = error instanceof AuthenticationError;
  let authUrl = "";
  if (isAuth) {
    authUrl = `/Security/login?BackURL=${window?.location?.href ?? "/"}`;
  }


  /**
   * Back button
   *
   * can't use react-router based history in error component so
   * this navigates back and forces a re-render
   */
  function back() {
    window?.history?.back();
    resetErrorBoundary();
  }

  return (
    <div className={`container ${styles.container}`}>
      <h2 className="noMargin">
        <Offline> You're offline </Offline>
        <Online> Whoops! Something has gone wrong </Online>
      </h2>
      <p className={styles.content}>
        <Offline> To view this content go online or check your connection and try again </Offline>
        <Online> We're having trouble displaying this page. Please try one of the options below.</Online>
      </p>
      {isAuth && (
        <p>
          You may need to <a href={authUrl}>log in</a> to view this content.
        </p>
      )}
      <div className={styles.actions}>
        <ButtonSecondary arrow="left" onClick={back}>
          Back
        </ButtonSecondary>
        <ButtonTertiary onClick={refresh}>
          <Restart className={styles.icon} />
          <Offline>Reload</Offline>
          <Online>Refresh</Online>
        </ButtonTertiary>
      </div>

      <div className={styles.bottom}>
        nothing works? Please try back later - or if problems continue{" "}
        <a href="#" className={styles.userData} onClick={deleteUserData}>
          click here to remove user data.
        </a>
      </div>
    </div>
  );
}
